var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.578 9.01277C14.7616 8.19637 13.4808 8.03231 12.5632 8.73312C10.9429 9.97072 9.527 11.4624 8.37501 13.1487C7.74895 14.0651 7.93561 15.2837 8.72039 16.0685L15.4952 22.8433C16.227 23.5751 16.227 24.7614 15.4952 25.4932L8.95765 32.0308C8.15835 32.8301 7.98173 34.0772 8.6419 34.9948C9.83323 36.6506 11.2838 38.1075 12.9341 39.3059C13.8518 39.9723 15.1041 39.7976 15.9061 38.9957L20.7339 34.1679C21.7823 33.1194 22.3713 31.6974 22.3713 30.2147V18.1218C22.3713 16.6391 21.7823 15.2171 20.7339 14.1686L15.578 9.01277Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9815 32.4231C39.798 33.2397 39.962 34.5208 39.2607 35.4384C38.0227 37.0583 36.5306 38.4738 34.8439 39.6253C33.9275 40.251 32.7093 40.0642 31.9247 39.2796L26.8132 34.1682C25.7648 33.1198 25.1758 31.6978 25.1758 30.215V18.1221C25.1758 16.6394 25.7648 15.2174 26.8132 14.1689L32.2616 8.72062C33.0607 7.92148 34.3075 7.74475 35.2251 8.40454C36.8813 9.59545 38.3385 11.0456 39.5374 12.6957C40.2042 13.6133 40.0295 14.866 39.2274 15.668L32.0518 22.8436C31.3201 23.5754 31.3201 24.7618 32.0518 25.4935L38.9815 32.4231Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a3f0d8f7d2d95db5cc80b8fa1d35f18f.svg";
export { ForwardRef as ReactComponent };